module.exports = __webpack_public_path__ + "static/img/restauration_2.fde9a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/restauration_2.jpg
// module id = cb3v
// module chunks = 1